import { CUSTOMERS_SECTION_ROUTES } from './Customers';
import { MESSAGES_ROUTES } from './Messages';

export const CUSTOMERS_ROUTES = {
  ...MESSAGES_ROUTES,
  ...CUSTOMERS_SECTION_ROUTES,
};
